import { render, staticRenderFns } from "./CreateTemplateLayoutModal.vue?vue&type=template&id=9910aab2"
import script from "./CreateTemplateLayoutModal.vue?vue&type=script&lang=js"
export * from "./CreateTemplateLayoutModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9910aab2')) {
      api.createRecord('9910aab2', component.options)
    } else {
      api.reload('9910aab2', component.options)
    }
    module.hot.accept("./CreateTemplateLayoutModal.vue?vue&type=template&id=9910aab2", function () {
      api.rerender('9910aab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/CreateTemplateLayoutModal.vue"
export default component.exports